module.exports = __webpack_public_path__ + "img/5.a2e66c31.jpg";